(function() {
  var LOW_STOCK_THRESHOLD = 5; // shows when 1-4 units remain
  var pairs = [];

  function getInventory() {
    var el = document.querySelector('[data-product-variants-inventory]');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function getVariantQty(variants, variantId) {
    var variant = variants.find(function(v) { return v.id === parseInt(variantId, 10); });
    if (!variant || variant.inventory_quantity === null || variant.inventory_management === null) {
      return null;
    }
    if (variant.inventory_policy === 'continue') {
      return null;
    }
    return variant.inventory_quantity;
  }

  function getCurrentVariantId() {
    var input = document.querySelector('input[name="id"]');
    return input ? input.value : null;
  }

  // A variant id is present in the DOM by default (Shopify preselects the
  // first variant) even before the shopper actually picks a size. Showing
  // "Only X left" for that un-chosen default is misleading -- the number
  // can be wrong/irrelevant once they pick the size they actually want.
  // Only show the badge once there's a real, explicit selection.
  function hasUserSelectedSize() {
    var controls = document.querySelectorAll('.pf-size-selected-text, .pf-floating-option-btn');
    if (controls.length === 0) return true; // no size-picker UI at all (single-variant product) -- always show
    for (var i = 0; i < controls.length; i++) {
      var text = (controls[i].textContent || '').trim();
      if (text && !/^select size$/i.test(text)) return true;
    }
    return false;
  }

  function makeBadge() {
    var badge = document.createElement('div');
    badge.className = 'pf-low-stock';
    badge.innerHTML = '<span class="pf-low-stock-dot"></span><span class="pf-low-stock-text"></span>';
    return badge;
  }

  function updateBadge(badge, btn) {
    if (!hasUserSelectedSize()) {
      if (badge.style.display !== 'none') badge.style.display = 'none';
      return;
    }

    var variants = getInventory();
    var variantId = getCurrentVariantId();
    var qty = variantId ? getVariantQty(variants, variantId) : null;
    var text = (btn.textContent || '').trim().toUpperCase();
    var soldOut = btn.disabled || text === 'SOLD OUT';

    if (!soldOut && qty !== null && qty > 0 && qty < LOW_STOCK_THRESHOLD) {
      var newText = 'Only ' + qty + ' left';
      var textEl = badge.querySelector('.pf-low-stock-text');
      if (textEl.textContent !== newText) textEl.textContent = newText;
      if (badge.style.display !== 'flex') badge.style.display = 'flex';
    } else {
      if (badge.style.display !== 'none') badge.style.display = 'none';
    }
  }

  function tick() {
    pairs.forEach(function(p) { updateBadge(p.badge, p.btn); });
  }

  function initLowStock() {
    document.querySelectorAll('.pf-atc-button, .pf-mobile-atc-button').forEach(function(btn) {
      if (btn.dataset.lowStockInit) return;
      btn.dataset.lowStockInit = 'true';
      var badge = makeBadge();
      var readyBadge = btn.parentNode.querySelector('.pf-ready-to-ship');
      if (readyBadge) {
        readyBadge.insertAdjacentElement('afterend', badge);
      } else {
        btn.parentNode.insertBefore(badge, btn);
      }
      pairs.push({ btn: btn, badge: badge });
      updateBadge(badge, btn);
    });

    document.querySelectorAll('.pf-floating-atc-btn').forEach(function(btn) {
      if (btn.dataset.lowStockInit) return;
      btn.dataset.lowStockInit = 'true';
      var row = btn.closest('.pf-floating-btn-row') || btn.parentNode;
      var badge = makeBadge();
      badge.classList.add('pf-low-stock--floating');
      var readyBadge = row.parentNode.querySelector('.pf-ready-to-ship--floating');
      if (readyBadge) {
        readyBadge.insertAdjacentElement('afterend', badge);
      } else {
        row.parentNode.insertBefore(badge, row);
      }
      pairs.push({ btn: btn, badge: badge });
      updateBadge(badge, btn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLowStock);
  } else {
    initLowStock();
  }
  setTimeout(initLowStock, 500);
  setTimeout(initLowStock, 1200);
  window.addEventListener('resize', initLowStock);

  // Poll continuously to catch variant switches regardless of how the
  // theme's custom size-picker UI updates the hidden variant id input
  // internally (it doesn't reliably fire 'change' events or mutate the
  // ATC button in a way a MutationObserver can catch on every switch).
  setInterval(tick, 300);
})();
